import { useEffect, useMemo, useRef, useState } from "react";
import { ReactComponent as Logo } from "@src/assets/CN/svg/logo.svg";
import { ReactComponent as International } from "@src/assets/CN/svg/international.svg";
import { ReactComponent as Call } from "@src/assets/CN/svg/call.svg";
import NavList from "./NavList";
import ContactModal from "@src/Components/CNComponents/ContactModal";
import { useTranslation } from "react-i18next";
import CNEnum from "@src/Locales/Constants/CNEnum";
import GlobalConfig from "@src/GlobalConfig";
import "./index.less";
import SwitchLanguage from "./SwitchLanguage";
import ContactContainer from "@src/Components/CNComponents/ContactContainer";
import { useLocation, useNavigate } from "react-router-dom";
import i18n from "@src/Basic/Language/i18n";
import NavWrap from "./NavWrap";
import { ReactComponent as ChevronDown } from "./svgs/chevron-down.svg";
import { ReactComponent as ChevronUp } from "./svgs/chevron-up.svg";
import { useParams, useSearchParams } from "react-router-dom";
import useNavList from "./useNavList";
import _ from "lodash";
import { isMobile } from "react-device-detect";
import { IKVProps } from "@src/Model/IKVProps";

const PCHeader = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname, state } = useLocation();
  const { navList } = useNavList();
  const [currentTab, setCurrentTab] = useState<string>("");
  const [activeNav, setActiveNav] = useState<string>(""); // product
  const [activeLabel, setActiveLabel] = useState<string>(""); // product label
  const [data, setData] = useState<any[]>([]);
  const [search] = useSearchParams();
  const { lang = "" } = useParams();
  const i18Language = useMemo(() => i18n.language, [i18n.language]);
  const [item, setItem] = useState<IKVProps>({});
  const [activeLabelNotStroke, setActiveLabelNotStroke] = useState("");
  const [isReset, setIsReset] = useState(false); // 鼠标mouseenter同一个tab,item不会变，这里需要触发headerWrapStyle的样式，给一个标识

  const path = useMemo(() => {
    return pathname.replace(`/${lang}`, "");
  }, [pathname]);

  useEffect(() => {
    const key = lang ? path.split("/")[1] : pathname.split("/")[2];
    setCurrentTab(_.find(data, { key })?.key);
  }, [data, path]);

  useEffect(() => {
    setActiveNav(_.find(_.find(data, { key: currentTab })?.content, { path })?.path);
  }, [data, path, currentTab]);

  console.log("active", activeLabel, activeNav, currentTab);

  useEffect(() => {
    const type = search.get("type");

    setActiveLabel(
      _.find(_.find(_.find(data, { key: currentTab })?.content, { path })?.list, {
        key: `${state?.anchor}${type || ""}`,
      })?.key
    );
  }, [data, path, currentTab, state, search]);

  useEffect(() => {
    setActiveLabelNotStroke(
      (_.find(_.find(data, { key: item.key })?.content)?.list,
      {
        path,
      })?.path
    );
  }, [data, path, currentTab]);

  useEffect(() => {
    setData(navList);
  }, [navList]);

  const handleChevron = (key: string, chevron: string) => {
    const newData = data.map((item) => {
      if (item.chevron && item.key === key) {
        item.chevron = chevron;
      } else {
        item.chevron && (item.chevron = "down");
      }
      return item;
    });
    setData(newData);
  };

  const handleNavigate = (item: any) => {
    navigate(`/${lang || i18Language}${item.path}`);
  };

  const handleTabNav = (item: any) => {
    const { path, key, content } = item;
    handleChevron(key, item.chevron === "up" ? "down" : "up");
    if (!content?.length) {
      navigate(`/${lang || i18Language}${path}`);
      key && setCurrentTab(key);
    }
  };

  const handleNavAnchor = (path: string, anchor: string, type?: string) => {
    const search = type ? `?type=${type}` : "";
    navigate(`/${lang}${path}${search}`, { state: { anchor } });
  };

  const Contact = useMemo(() => {
    return (
      <div className="flex items-center ml-[32PX]">
        <ContactContainer>
          <div className="contact flex items-center">
            <Call />
            <span className="text-white ml-[2px]">{t(CNEnum.contactUs)}</span>
          </div>
        </ContactContainer>
      </div>
    );
  }, [i18n.language]);

  const handleMouseEnter = (item: IKVProps) => {
    if (isMobile) return;
    setItem(item);
    handleChevron(item.key, "up");
    setIsReset(true);
  };

  const handleMouseLeave = () => {
    if (isMobile) return;
    setIsReset(false);
    // setItem({});
    // setShowNavWrap(false);
    // handleChevron(item.key, "down");
  };

  const headerWrapStyle = useMemo(() => {
    console.log("headerWrapStyleItem", item);
    if (item.chevron === "up") {
      // 显示底下bottom
      return { borderBottom: "1px solid #DDDEE0" };
    }

    // // 产品功能下菜单选中
    // if (item.chevron === "up" && activeLabel && activeNav) {
    //   return { borderBottom: "1px solid #DDDEE0" };
    // }

    // 显示底部阴影
    if (currentTab) return { boxShadow: "3.5PX 23.5PX 30.6PX 0 rgba(25, 52, 97, 0.08)" };

    return undefined;
  }, [item, currentTab, activeLabel, activeNav, isReset]);

  return (
    <div className={`headerWrap relative`} style={headerWrapStyle}>
      <header className="header m-auto flex items-center justify-between w-full">
        <div
          className="logo cursor-pointer"
          onClick={() => {
            navigate("/");
          }}
        ></div>
        <div className="PCNavList flex h-full">
          {data.map((item: any) => {
            return (
              <div
                className="h-full"
                key={item.key}
                onMouseEnter={() => handleMouseEnter(item)}
                onMouseLeave={handleMouseLeave}
                onClick={(e) => {
                  if (isMobile && item.chevron) {
                    handleChevron(item.key, item.chevron === "up" ? "down" : "up");
                  } else {
                    handleTabNav(item);
                  }
                }}
              >
                <div
                  id={`tabTitle${item.key}`}
                  className={`tabTitle h-full flex items-center cursor-pointer ${
                    currentTab === item.key ? "activeTab" : ""
                  }`}
                >
                  <span>{item.title}</span>
                  {item.chevron && (
                    <ChevronDown
                      className={`ml-[6PX] ${item.chevron === "up" ? "chevronUp" : "chevronDown"}`}
                    />
                  )}
                </div>
              </div>
            );
          })}
        </div>
        <div className="flex justify-around h-full">
          <SwitchLanguage setItem={setItem} />
          {Contact}
        </div>
      </header>
      {item.chevron === "up" && (
        <div
          className="navWrapBg absolute w-full"
          onMouseEnter={() => {
            //
          }}
          onMouseLeave={() => setItem({})}
        >
          <div className="navWrapContent m-auto relative flex justify-between">
            <NavWrap
              data={data}
              currentTab={currentTab}
              activeNav={activeNav}
              activeLabel={activeLabel}
              handleNavigate={handleNavigate}
              handleNavAnchor={handleNavAnchor}
              handleChevron={handleChevron}
              item={item}
              activeLabelNotStroke={activeLabelNotStroke}
            />
          </div>
          <div className="navWrapBottom"></div>
        </div>
      )}
    </div>
  );
};
export default PCHeader;
